import { useLang } from "@/context/LanguageContext";
import { scrollToId } from "@/components/mobix/Navbar";
import Logo from "@/components/mobix/Logo";
import { MapPin, Mail, Phone } from "lucide-react";

export default function Footer() {
  const { t } = useLang();

  const navLinks = [
    { id: "products", key: "products" },
    { id: "about", key: "about" },
    { id: "news", key: "news" },
    { id: "showroom", key: "showroom" },
  ];

  return (
    <footer className="relative bg-white text-mobix-navy overflow-hidden" data-testid="footer">
      <div className="relative z-10 max-w-[1800px] mx-auto px-6 md:px-12 lg:px-20 pt-20 pb-8">
        <div className="grid grid-cols-12 gap-10 pb-14">
          {/* Brand */}
          <div className="col-span-12 lg:col-span-5">
            <Logo className="h-14 sm:h-16 w-auto" />
            <p className="mt-3 text-sm font-bold tracking-[0.32em] uppercase text-mobix-orange">
              Precision In Motion
            </p>
          </div>

          {/* Navigation */}
          <div className="col-span-6 lg:col-span-3">
            <p className="text-[11px] font-bold tracking-[0.2em] uppercase text-mobix-orange mb-5">{t.footer.nav}</p>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.key}>
                  <button
                    onClick={() => scrollToId(l.id)}
                    data-testid={`footer-link-${l.key}`}
                    className="text-sm font-medium text-mobix-navy/70 hover:text-mobix-orange transition-colors duration-300"
                  >
                    {t.nav[l.key]}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacts */}
          <div className="col-span-12 lg:col-span-4">
            <p className="text-[11px] font-bold tracking-[0.2em] uppercase text-mobix-orange mb-5">{t.footer.contact}</p>
            <ul className="space-y-4 text-sm text-mobix-navy/75">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-mobix-orange mt-0.5 shrink-0" />
                <span className="min-w-0 break-words">{t.contact.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-mobix-orange shrink-0" />
                <a href={`tel:${t.contact.phoneValue.replace(/\s/g, "")}`} className="hover:text-mobix-orange transition-colors">{t.contact.phoneValue}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-mobix-orange shrink-0" />
                <a href={`mailto:${t.contact.emailValue}`} className="hover:text-mobix-orange transition-colors">{t.contact.emailValue}</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-mobix-navy/10 pt-8 flex flex-col items-center gap-4 text-center">
          <p className="text-xs text-mobix-navy/60 leading-relaxed" data-testid="footer-copyright">
            Copyright © 2026 - All rights reserved - Mala Aleja 67, 71210 Ilidža, Bosna i Hercegovina
            <br />
            tel. +387 60 323 6229 - info@mobix.ba
          </p>

          <div className="flex items-center gap-3 text-xs font-semibold">
            <a
              href="/docs/privacy-policy.pdf"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-privacy"
              className="text-mobix-navy/70 hover:text-mobix-orange transition-colors"
            >
              Privacy Policy
            </a>
            <span className="text-mobix-navy/30">|</span>
            <a
              href="/docs/cookie-policy.pdf"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-cookie"
              className="text-mobix-navy/70 hover:text-mobix-orange transition-colors"
            >
              Cookie Policy
            </a>
          </div>

          <p className="text-xs text-mobix-navy/45">designed by Beba &amp; Co. - July 2026</p>
        </div>
      </div>
    </footer>
  );
}
